import { useHistory, useLocation } from "react-router-dom";

import { TabButtons, TabHealthera } from '../../healtheraComponents';

const routes = [
  { path: '/services/consultations', tab: 0, label: 'Consultations' },
  { path: '/services/conditions', tab: 1, label: 'Conditions' },
];

const getActiveTab = (url) => {
  return routes.find(({ path }) => url === path)?.tab ?? null;
};

const getRouteByTab = (tabIndex) => {
  return routes.find(({ tab }) => tab === tabIndex)?.path;
}

function ServicesTabs() {
  const location = useLocation();
  const history = useHistory();
  
  function handleTabChange(_, tabIndex) {
    const selectedTab = getActiveTab(location.pathname);
    if (selectedTab === tabIndex) return;
    history.push(getRouteByTab(tabIndex) || '/');
  }

  const activeTab = getActiveTab(location.pathname);
  if (activeTab === null) return null;

  return (
    <TabButtons
      height={`64px`}
      value={activeTab}
      onChange={handleTabChange}>
      {routes.map(route => <TabHealthera key={route.path} label={route.label} />)}
    </TabButtons>
  );
}

export default ServicesTabs;
